import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/IMG_4648.jpg'
import _imports_1 from '../assets/img/IMG_4647.png'


const _withScopeId = n => (_pushScopeId("data-v-cef6264e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "grid-card" }
const _hoisted_3 = { class: "icon-holder" }
const _hoisted_4 = { class: "icon-background" }
const _hoisted_5 = { class: "title-holder" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "text-holder" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 0,
  class: "image-container"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"image-box\" data-v-cef6264e><img src=\"" + _imports_0 + "\" alt=\"about_daniel.jpg\" data-v-cef6264e><img src=\"" + _imports_1 + "\" alt=\"about_christopher.jpg\" data-v-cef6264e></div><div class=\"image-text\" data-v-cef6264e><p class=\"daniel\" data-v-cef6264e>Daniel Oskarsson</p><p class=\"christopher\" data-v-cef6264e>Christopher Oskarsson</p></div>", 2)
const _hoisted_19 = [
  _hoisted_17
]
const _hoisted_20 = {
  key: 0,
  class: "button-holder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Icon, {
            class: "icon-style",
            icon: _ctx.icon,
            color: "white",
            rotate: _ctx.iconRotate,
            horizontalFlip: _ctx.iconFlip
          }, null, 8, ["icon", "rotate", "horizontalFlip"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.coloredPart)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.title), 1),
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.titleLineTwo) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.coloredTitlePart), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.twoLineTitle)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.title), 1),
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.titleLineTwo), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.coloredPart && !_ctx.twoLineTitle)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_10, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.hasList)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("ul", {
                  key: item.id
                }, [
                  _createElementVNode("li", null, _toDisplayString(item.text), 1)
                ]))
              }), 128))
            ]))
          : (!_ctx.hasList && _ctx.hasContact)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                _createElementVNode("span", null, [
                  _createVNode(_component_Icon, {
                    icon: "mdi:email",
                    color: "#7f9a65"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.email), 1)
                ]),
                _hoisted_14,
                _createElementVNode("span", null, [
                  _createVNode(_component_Icon, {
                    icon: "raphael:iphone",
                    color: "#7f9a65"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.phone), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.text), 1))
      ]),
      (_ctx.hasImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
        : _createCommentVNode("", true)
    ]),
    (_ctx.hasButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.buttonEvent && _ctx.buttonEvent(...args)))
          }, _toDisplayString(_ctx.buttonName), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}